import '../pages.scss';
import './home.scss';

import { Link } from 'react-router-dom';
import { SelectedWork } from '../../components/portfolio/SelectedWork';
import { Customers } from '../../components/sections/customers/Customers';
import { Services } from '../../components/sections/services/Services';

export const Home = () => {
  return (
    <>
      <Hero />
      <div className="home-section home-section--services">
        <Services />
      </div>
      <div className="home-section home-section--works">
        <SelectedWork />
      </div>
      <div className="home-section home-section--clients">
        <Customers />
      </div>
    </>
  );
};

export const Hero = () => {
  return (
    <div className="home-section home-section--hero">
      <section
        className="jarallax position-relative d-flex align-items-center"
        data-jarallax=""
        data-img-position="0% 100%"
        data-speed="0.5"
      >
        <div className="container position-relative zindex-5">
          <div className="row justify-content-md-start justify-content-center">
            <div className="col-md-8 col-sm-8 order-md-1 order-2 d-flex flex-column justify-content-between mt-4 pt-2 text-md-start text-center">
              <div>
                <div className="d-inline-flex align-items-center position-relative mb-3 hero">
                  <b className="mb-0 hero-title">
                    Reliable software for complex operations
                  </b>
                </div>

                <h3 className="display-2 mb-md-4">
                  Building <span className="text-gradient-primary">software systems that scales </span>with your organization.
                </h3>
                <div className="d-md-flex align-items-md-start mb-md-3 pb-xl-2">
                  <p className="d-lg-block d-none mb-0 text-dark">
                  
        Ounic designs and develops custom systems, internal tools, and AI-powered platforms used by teams to automate workflows, manage operations, and deliver reliable products.
        </p>
        <p className="d-lg-block d-none mb-0">

                  </p>
                </div>
                <div className="d-md-flex align-items-md-start mb-md-3 pb-xl-2">
                  <p className="d-lg-block d-none mb-0 text-dark">
                  
{/* Trusted by teams across fintech, healthcare, education, and global organizations. */}
        </p>
        <p className="d-lg-block d-none mb-0">

                  </p>
                </div>
                <div className="d-md-flex align-items-md-start">
                  <a href="mailto:ask@ounic.co" className="btn btn-lg btn-primary flex-shrink-0 me-md-4 mb-md-0 mb-sm-4 mb-3 hero-cta">
                    Book a Discovery Call
                  </a>
                  <Link to="/our-works" className="btn btn-lg btn-link flex-shrink-0 me-md-4 mb-md-0 mb-sm-4 mb-3 hero-cta">
                    View Case Studies
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
